/// <amd-module name="Build/PipelineInsights/RunsInsights/Constants" />
export const PipelineInsightsClientSettings = "pipelines/runs/insights";

export namespace Telemetry {
    export const Area = "PipelineInsights";
    export const RunsInsightsViewReport = "RunsInsightsViewReport";
    export const RunsInsightsOnDismiss = "RunsInsightsOnDismiss";
    export const RunsInsightsOnError = "RunsInsightsOnError";
    export const RunsInsightsTriggerData = "RunsInsightsTriggerData";
}

export const serviceInstanceId = "0000003c-0000-8888-8000-000000000000";
